module.exports = __webpack_public_path__ + "static/media/guru.bfe6d13a.png";